import {
  getSessionStorageItem,
  setSessionStorageItem,
  removeSessionStorageItem,
} from '@revenuemarket/browser';

const SESSION_KEY = 'company_invitation_session';

export interface CompanyInvitationSession {
  token: string;
}

export function getCompanyInvitationSession(): CompanyInvitationSession | undefined {
  return getSessionStorageItem<CompanyInvitationSession>(SESSION_KEY);
}

export function setCompanyInvitationSession(session: CompanyInvitationSession) {
  setSessionStorageItem(SESSION_KEY, session);
}

export function removeCompanyInvitationSession() {
  removeSessionStorageItem(SESSION_KEY);
}
